<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="regulationTargetType" label="奖惩对象类型">
          <j-dict-select-tag placeholder="请选择奖惩对象类型" dictCode="regulation_target_type" v-model="model.regulationTargetType"/>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="regulationType" label="奖惩类型">
          <j-dict-select-tag placeholder="请选择奖惩类型" dictCode="regulation_type" v-model="model.regulationType"/>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="regulationTargetCode" label="奖惩对象代码">
          <a-input placeholder="奖惩对象代码" v-model="model.regulationTargetCode"/>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="regulationContent" label="奖惩内容">
          <a-input placeholder="请输入奖惩内容" v-model="model.regulationContent"/>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="personLiable" label="信息申报责任人">
          <a-input placeholder="请输入信息申报责任人" v-model="model.personLiable"/>
        </a-form-model-item>

        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="regulationTime" label="奖惩时间">
          <j-date v-model="model.regulationTime">
          </j-date>
        </a-form-model-item>

<!--        <a-upload-->
<!--          name="file"-->
<!--          :action="uploadAction"-->
<!--          :headers="tokenHeader"-->
<!--          accept=".jpg, .jpeg, .png, .pdf"-->
<!--          :showUploadList="false"-->
<!--          :beforeUpload="beforeUpload"-->
<!--          @change="handleChangeRegulationRecordsDoc"-->
<!--          :multiple="false"-->
<!--          style="margin-left: 155px;">-->
<!--          <a-button>-->
<!--            <a-icon type="upload"/>-->
<!--            资质扫描件-->
<!--          </a-button><span style="color:red;padding-left:10px;">可上传的格式有：.jpg, .jpeg, .png, .pdf</span>-->
<!--        </a-upload>-->

      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
  import {FzisListMixin} from '@/mixins/FzisListMixin'
  import Vue from 'vue';
  import {ACCESS_TOKEN} from "@/store/mutation-types";
  import {httpAction} from '@/api/manage'

  export default {
    name: "tmEnterpriseRegulationRecordsModal",
    mixins: [FzisListMixin],
    data() {
      return {
        title: "操作",
        visible: false,
        model: {},
        labelCol: {
          xs: {span: 24},
          sm: {span: 5},
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16},
        },

        confirmLoading: false,
        validatorRules: {
          regulationTargetType: [{required: true, message: '请输入正确的奖惩对象类型!'}],
          regulationType: [{required: true, message: '请输入正确的奖惩类型!'}],
          regulationTargetCode: [{required: true, message: '请输入正确的奖惩对象代码!'}],
          regulationContent: [{required: true, message: '请输入正确的奖惩内容!'}],
          personLiable: [{required: true, message: '请输入正确的信息申报责任人!'}],
          regulationTime: [{required: true, message: '请输入奖惩时间!'}],
        },
        tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
        url: {
          add: "/ebid-ce/tmEnterpriseRegulationRecords/add",
          edit: "/ebid-ce/tmEnterpriseRegulationRecords/edit",
          minioUpload: "/ebid-ce/file/upload",
        },
      }
    },
    created() {
    },
    computed: {
      uploadAction() {
        return window._CONFIG['domianURL'] + this.url.minioUpload;
      },
    },
    methods: {
      add() {
        //初始化默认值
        this.edit({});
      },
      edit(record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close() {
        this.$emit('close');
        this.visible = false;
        this.$refs.form.clearValidate();
      },
      handleOk() {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += that.url.add;
              method = 'post';
            } else {
              httpurl += that.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          } else {
            return false;
          }
        })
      },
      handleCancel() {
        this.close()
      },
      handleChangeRegulationRecordsDoc(info) {
        if (info.file.status === 'done') {
          if (info.file.response.success) {
            this.loadData()
            this.$message.success(`${info.file.name} 上传成功!`);
            this.hasBusinessLicenseFile = true;
          } else {
            this.$message.error(`${info.file.response.message}`);
          }
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.response.message}`);
        }
      },
      beforeUpload(file) {
        return true
      },
    }
  }
</script>

<style lang="less" scoped>

</style>